// @ts-nocheck

import { HISTORY_PAGE_SIZE } from '../constants';
import { GridsActionTypes } from '../types/actions';
import type {
  AskHistoryGridType,
  AskHistoryGridsType,
  SetHistoryGridCountType,
  SetHistoryFetchingType,
  SetHistoryNextPageType,
  SetHistoryPrevPageType,
  SetHistoryFilterType,
  SetHistoryPageType,
  SetHistoryReferencesType,
} from '../types/actions';

export const askHistoryGrids: AskHistoryGridsType = (offset = 0) => ({
  type: GridsActionTypes.ASK_HISTORY_GRIDS,
  payload: {
    offset,
  },
});

export const askHistoryGrid: AskHistoryGridType = (gridReference) => ({
  type: GridsActionTypes.ASK_HISTORY_GRID,
  payload: {
    gridReference,
  },
});

export const setHistoryGridCount: SetHistoryGridCountType = (gridCount) => {
  return {
    type: GridsActionTypes.SET_HISTORY_GRID_COUNT,
    payload: { gridCount },
  };
};

export const setHistoryFetching: SetHistoryFetchingType = (isFetching) => ({
  type: GridsActionTypes.SET_HISTORY_FETCHING,
  payload: { isFetching },
});

export const setHistoryReferences: SetHistoryReferencesType = (gridReferences) => ({
  type: GridsActionTypes.SET_HISTORY_REFERENCES,
  payload: { gridReferences },
});

export const setHistoryNextPage: SetHistoryNextPageType = () => (dispatch, getState) => {
  const { currentPage, gridCount } = getState().grids.history;
  const maxPages = Math.ceil(gridCount / HISTORY_PAGE_SIZE);
  const nextPage = currentPage < gridCount ? currentPage + 1 : maxPages;
  dispatch(setHistoryPage(nextPage));
};

export const setHistoryPrevPage: SetHistoryPrevPageType = () => (dispatch, getState) => {
  const { currentPage } = getState().grids.history;
  const nextPage = currentPage > 0 ? currentPage - 1 : 0;
  dispatch(setHistoryPage(nextPage));
};

export const setHistoryPage: SetHistoryPageType = (currentPage) => ({
  type: GridsActionTypes.SET_HISTORY_PAGE,
  payload: { currentPage },
});

export const setHistoryFilter: SetHistoryFilterType = (filter) => ({
  type: GridsActionTypes.SET_HISTORY_FILTER,
  payload: { filter },
});
